import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect } from "react";
import { applyConsent } from "../others";
import { getOtherOptionsFromWindow } from "../utils";
import { isCrawler } from "../utils/isCrawler";
import matches from "matches-selector";

function useBannerShortcodeLinks(setContextValue, toggleOverlay) {
  useEffect(function () {
    var eventListener = function eventListener(e) {
      var link = e.target;

      if (matches(link, ".rcb-sc-link")) {
        // Do not allow links for crawlers
        if (isCrawler()) {
          alert(getOtherOptionsFromWindow().bannerI18n.crawlerLinkAlert);
        } else {
          var type = link.getAttribute("href").slice(1);

          if (type === "revoke") {
            _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _getOtherOptionsFromW, essentialGroup, groups, _groups$filter, _groups$filter2, essentialGroupObj, successMessage;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      // Do not rely on current state of `groups` because it can be altered through history change
                      _getOtherOptionsFromW = getOtherOptionsFromWindow(), essentialGroup = _getOtherOptionsFromW.essentialGroup, groups = _getOtherOptionsFromW.groups;
                      _groups$filter = groups.filter(function (_ref2) {
                        var slug = _ref2.slug;
                        return slug === essentialGroup;
                      }), _groups$filter2 = _slicedToArray(_groups$filter, 1), essentialGroupObj = _groups$filter2[0];
                      _context.next = 4;
                      return applyConsent({
                        consent: {
                          groups: _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref3) {
                            var id = _ref3.id;
                            return id;
                          }))
                        },
                        buttonClicked: "shortcode_revoke"
                      });

                    case 4:
                      // Always reload (always wait 2s to ensure opt-out scripts are exeucted)
                      successMessage = link.getAttribute("data-success-message");
                      successMessage && alert(successMessage);
                      setTimeout(function () {
                        window.location.reload();
                      }, 2000);

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          } else {
            setContextValue(function (state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                activeAction: type,
                individualPrivacyOpen: true
              }, toggleOverlay(state, true));
            });
          }
        }

        e.preventDefault();
      }
    };

    document.addEventListener("click", eventListener);
    return function () {
      document.removeEventListener("click", eventListener);
    };
  }, []);
}

export { useBannerShortcodeLinks };